<template>
  <van-action-sheet v-model="show">
    <div class="pl15 pt15 pr15 pb15">
      <div class="pos-a l0 t0 r0 pl15 pt15 pr15 bg-F zi-1">
        <div class="flex jc-sb">
          <p class="flex-1 ta-c f16 color-2">请选择退款商品</p>
          <img
            class="close_size20"
            src="../../../assets/images/close3.png"
            alt=""
            @click="close()"
          />
        </div>
        <div class="flex jc-sb mt20 mb10">
          <van-checkbox
            class="f12 fw-b color-3"
            v-model="checkedAll"
            @click="checkedAllHandle"
            checked-color="#EF203F"
            :disabled="
              (order.is_part_refund == 0 && order.orderstatus == 2) ||
              order.is_coupon == 1 ||
              order.isMayTwentyAct != 0
            "
          >
            全选
          </van-checkbox>
          <div class="f12 ws-n color-6C">{{ order.order_from }}&nbsp;{{ order.no }}</div>
        </div>
      </div>
      <div style="min-height: 0.63rem"></div>

      <van-checkbox-group
        v-model="selectedGoods"
        ref="checkboxGroupDom"
        @change="changeBoxHandle"
        checked-color="#EF203F"
        :disabled="
          (order.is_part_refund == 0 && order.orderstatus == 2) ||
          order.is_coupon == 1 ||
          order.isMayTwentyAct != 0
        "
      >
        <div
          class="bg-F mt10 mb10 radius-4px flex-1"
          v-for="item of goodsList"
          :key="item.ordersheet_id"
        >
          <div class="flex">
            <van-checkbox :name="item" />
            <div class="flex ml7 flex-1">
              <div class="pos-r">
                <img class="goods_size80 radius-4px" v-lazy="item.img_path" alt="" />
                <goods-tag :goods="item"></goods-tag>
              </div>
              <div class="ml7 flex-1 pb25 f0 pos-r">
                <div class="flex jc-sb">
                  <div class="f13 color-29">{{ item.name }}</div>
                  <div class="f13 color-6C">x{{ parseInt(item.refundNum || 0) }}</div>
                </div>
                <div class="d-ib color-6C f11 pt2 pb2 pr8 mt5">
                  {{ item.spec }}
                </div>
                <p class="color-2 fw-b f13 pos-a l0 b0 mb3">¥{{ item.price }}</p>
                <div class="pos-a b0 r0">
                  <van-stepper
                    :long-press="false"
                    integer
                    v-model="item.curNum"
                    :min="
                      (order.is_part_refund == 0 && order.orderstatus == 2) ||
                      order.is_coupon == 1 ||
                      order.isMayTwentyAct != 0
                        ? item.refundNum
                        : 1
                    "
                    :max="parseInt(item.refundNum || 0)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="ml20 pl7">
            <div
              class="flex jc-sb ai-c f11 color-29 mt10 mb10"
              v-if="item.giftList && item.giftList.length == 1"
            >
              <div class="flex ai-c f11">
                <img class="goods_size31 radius-4px" v-lazy="item.giftList[0].img_path" alt="" />
                <div class="over-ell-2 ml5 mr5 color-29">
                  {{ item.giftList[0].name }}
                </div>
              </div>
              <div class="ws-n">赠品X{{ item.giftList[0].num }}</div>
            </div>
            <div
              class="flex ai-c f11 color-29 mt10 mb10 w-100 scroll-x scrollbar-none"
              v-else-if="item.giftList && item.giftList.length > 1"
            >
              <div
                class="flex ai-c f11 ws-n"
                v-for="(giftItem, giftIndex) of item.giftList"
                :class="[giftIndex != 0 ? 'ml20' : '']"
              >
                <img class="goods_size31 radius-4px" v-lazy="giftItem.img_path" alt="" />
                <div class="ml5 mr5 color-29">赠品{{ giftIndex + 1 }}&nbsp;X{{ giftItem.num }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="ml20 pl7 line-b-D8 pt10" v-if="order.fullGiftList && order.fullGiftList.length">
          <div
            class="flex jc-sb ai-c f11 color-29 mb10"
            v-if="order.fullGiftList && order.fullGiftList.length == 1"
          >
            <div class="flex ai-c f11">
              <img class="goods_size31 radius-4px" v-lazy="order.fullGiftList[0].img_path" alt="" />
              <div class="over-ell-2 ml5 mr5 color-29">
                {{ order.fullGiftList[0].name }}
              </div>
            </div>
            <div class="ws-n">赠品X{{ order.fullGiftList[0].num }}</div>
          </div>
          <div
            class="flex ai-c f11 color-29 mb10 w-100 scroll-x scrollbar-none"
            v-else-if="order.fullGiftList && order.fullGiftList.length > 1"
          >
            <div
              class="flex ai-c f11 ws-n"
              v-for="(giftItem, giftIndex) of order.fullGiftList"
              :class="[giftIndex != 0 ? 'ml20' : '']"
            >
              <img class="goods_size31 radius-4px" v-lazy="giftItem.img_path" alt="" />
              <div class="ml5 mr5 color-29">赠品{{ giftIndex + 1 }}&nbsp;X{{ giftItem.num }}</div>
            </div>
          </div>
        </div>
      </van-checkbox-group>
      <div class="footerIOS" style="min-height: 0.63rem"></div>
      <footer class="footerIOS bg-F">
        <button class="btn" :disabled="!selectedGoods.length" @click="submitHandle">下一步</button>
      </footer>
    </div>
  </van-action-sheet>
</template>

<script>
import goodsTag from '../../common/goodsTag'
export default {
  data() {
    return {
      show: false,
      selectedGoods: [],
      checkedAll: false,
      showquan: false
    }
  },
  components: {
    goodsTag
  },
  props: {
    goods: {
      type: Array,
      default: () => []
    },
    order: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.checkedAll = false
        this.selectedGoods = []
      }
    }
  },
  computed: {
    goodsList() {
      if (Array.isArray(this.goods) && this.goods.length) {
        if (
          this.show &&
          ((this.order.is_part_refund == 0 && this.order.orderstatus == 2) ||
            this.order.is_coupon == 1 ||
            this.order.isMayTwentyAct != 0)
        ) {
          this.$nextTick(() => {
            this.selectedGoods = this.goods
            this.checkedAll = true
          })
        }
        return this.goods
      }
    }
  },
  methods: {
    changeBoxHandle() {
      if (this.goodsList.length == this.selectedGoods.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    checkedAllHandle() {
      this.$refs.checkboxGroupDom.toggleAll(this.checkedAll)
    },
    submitHandle() {
      if (this.selectedGoods.length > 0) {
        this.$emit('submit', this.selectedGoods)
      }
    },
    open() {
      this.show = true
      this.$emit('open')
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/common/css/footerSubmit';
</style>



// WEBPACK FOOTER //
// src/components/order/components/orderGoodsCheck.vue